import { forwardRef, type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import cn from 'classnames';

const tickerInnerVariants = cva('', {
  variants: {
    variant: {
      'black-30-main':
        'bg-black/30 backdrop-blur-[32px] rounded-bl-lg rounded-tr-lg px-2 py-1',
    },
    text: {
      'xs-medium': 'text-[12px] font-medium',
    },
  },
});

interface TickerInnerProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof tickerInnerVariants> {
  label: string;
}

const TickerInner = forwardRef<HTMLDivElement, TickerInnerProps>(
  ({ variant, text, label, ...props }, ref) => {
    return (
      <div
        ref={ref}
        {...props}
        className={cn(
          tickerInnerVariants({ variant, text }),
          props.className,
          'leading-none',
        )}
      >
        {label}
      </div>
    );
  },
);

export { TickerInner };
